<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        center
        class="detail-dialog-container"
        width="500px">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">添加外部联系人</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="form" labelWidth="auto">
                <el-form-item label="机构名称" prop="name">
                    <el-input v-model="ruleForm.name"  placeholder="请输入机构名称"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="ruleForm.email"  placeholder="请输入邮箱"></el-input>
                </el-form-item>

            </el-form>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">取消</el-button>
                <el-button :loading="loading" class="operate" @click="submitForm('ruleForm')">
                    保存
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import rules from '@/utils/rules'

export default {
    name: "AddOhterMemberDialog",
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            ruleForm: {
                email: '',
                name: '',
            },
            rules: {
                email: [
                    {required: true, message: '请输入邮箱', trigger: 'blur'},
                    rules.email
                ],
                name: [
                    {required: true, message: '请输入机构名称', trigger: 'blur'}
                ],
            },

        }
    },
    created() {
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('saveOther', this.ruleForm)
                    this.cancel()
                }
            });
        },
        cancel() {

            this.$emit('watchState', false)
        }
    },
    watch: {
        applyDialogVisible() {
            if (this.applyDialogVisible) {
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields();
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .login-input {
            position: relative;

            .code-text {
                position: absolute;
                right: 12px;
                top: 50%;
                transform: translateY(-50%);
                color: #0a2240;
                cursor: pointer;
            }
        }

        .dialog-operate {
            margin-top: 20px;

            .operate {
                width: 200px;
                height: 40px;
                border-radius: 20px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;

                &.black {
                    background: #0a2240 none;
                }
            }

            .operate + .operate {
                margin-left: 80px;
            }
        }

        .dialog-footer {
            height: 40px;
            background-color: #e7eff9;
            padding: 0 20px;
            border-radius: 0 0 10px 10px;

            .content {
                font-size: 16px;
                color: #8b9fbe;
            }
        }
    }
}
</style>